import { render } from "./LwPageHeader.vue?vue&type=template&id=6d3f571a&scoped=true"
import script from "./LwPageHeader.vue?vue&type=script&lang=js"
export * from "./LwPageHeader.vue?vue&type=script&lang=js"

import "./LwPageHeader.vue?vue&type=style&index=0&id=6d3f571a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3f571a"]])

export default __exports__